<script>
import { h } from 'vue';
import { Form, FormItem, Button, Tag, Input, InputPassword, InputNumber } from 'ant-design-vue';
import DolFormItem from '@/components/dolphin-ant-design/form/dol-form-item.vue';

export default {
  name: 'dol-edit-form',
  components: { DolFormItem },
  props: {
    fields: { type: Object, default: () => [] },
    form: { type: Object, default: () => ({}) },
    layout: { type: String, default: 'vertical' }, // horizontal | vertical | inline
    rules: { type: Object, default: () => ({}) },
    asEdit: { type: Boolean },

    // 表单样式
    labelWidth: { type: String, default: null }, // 100px | null
  },
  computed: {
    innerFields() {
      // 过滤出需要显示的字段
      const showFields = this.fields.filter(item => {
        if (item.editHidden) return false;
        if (this.asEdit && item.editParams?.onlyAdd === true) return false;
        if (typeof item.editParams?.show !== 'undefined') return !!item.editParams.show;
        if (typeof item.editParams?.check === 'function') return !!item.editParams.check(this.form, item);
        return item.dataIndex !== 'operation';
      });

      // 处理特殊格式
      return showFields.map(item => {
        const field = { ...item };
        if (typeof field.editParams?.disabled !== 'undefined') {
          field.innerParams = { disabled: item.editParams.disabled, disable: item.editParams.disabled };
        }
        return field;
      });
    },
  },
  data() {
    return {};
  },
  methods: {
    refresh() {
      this.$emit('refresh');
    },

    // 透传方法
    clearValidate() {
      if (this.$refs.editForm) {
        this.$refs.editForm.clearValidate();
      }
    },
    validate() {
      if (this.$refs.editForm) {
        return this.$refs.editForm.validate();
      } else {
        return Promise.resolve();
      }
    },
  },
  render() {
    const formParams = {
      class: `dol-edit-form`,
      layout: this.layout,
      labelCol: { style: { width: this.labelWidth } },
      autocomplete: false,
      model: this.form,
      rules: this.rules,
      ref: 'editForm',
    };
    const formChildren = [];
    // 测试数据
    // formChildren.push(h('div', JSON.stringify(this.rules)))

    // 表单项
    this.innerFields.forEach(field => {
      // 外部自定义渲染
      if (field.inputType === 'customer' && this.$slots.formItem) {
        formChildren.push(this.$slots.formItem({ field, form: this.form }));
        return true;
      }

      // 使用公共组件渲染
      const formItemParams = {
        field: field,
        form: this.form,
      }
      if (field.editParams?.ref) {
        formItemParams.ref = field.editParams.ref;
      }
      formChildren.push(h(DolFormItem, formItemParams, () => undefined));
    });

    return h(Form, formParams, () => formChildren);
  },
}
</script>

<style lang="scss">

</style>
